<template>
  <div class="flex">
    <div class="flex-1">
      <div class="multiple-choice-item choice-item py-1.5 px-2" :class="{ 'choice-checked': isCheck }">
        <van-checkbox :disabled="disabled" :name="item.id" shape="square" @click="onClick">
          <div class="flex" :class="textColorClass">
            <div class="flex-1">
              <div v-html="itemText" ref="text"></div>
            </div>
            <template v-if="item.tips">
              <van-popover placement="left-start" style="height: 16px" v-model="showPopover" trigger="click">
                <div class="py-2 px-4 max-w-full">
                  <p style="width: 150px;max-height: 150px;overflow: auto">
                    {{ item.tips }}
                  </p>
                  <div class="text-right">
                    <van-button size="mini" text @click="showPopover = false">关闭</van-button>
                  </div>
                </div>
                <template #reference>
                  <van-icon name="question-o" @click.native.stop="showPopover = true" />
                  <span class="text-small text-theme-black-350" @click.stop="showPopover = true" v-if="answerTipIconText">{{ answerTipIconText }}</span>
                </template>
              </van-popover>
            </template>
          </div>
          <template v-slot:icon="{ checked }">
            <icon-checkbox :value="checked" :disabled="disabled" />
          </template>
        </van-checkbox>
      </div>
    </div>
    <div v-if="correctAnswerList.length" style="width: 100px">
      <template v-if="isCorrectAnswer">
        <div class="flex flex-col text-center" :class="{ 'py-2': !correct.score }">
          <span v-if="correct.score" class="text-theme-black-450 text-medium">{{ correct.score }}分</span>
          <span class="text-green-theme text-medium">正确答案</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import IconCheckbox from '@/components/base/IconCheckbox'
import { appendQuotaText } from 'dygc'

export default {
  name: 'MultipleChoiceItem',
  components: { IconCheckbox },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    item: {
      type: Object,
      default: () => ({})
    },
    correctAnswerList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showPopover: false
    }
  },
  computed: {
    answerTipIconText(){
      if(!this.$bus) return ''
      return this.$bus.survey?.otherSetting?.answerTipIconText
    },
    textColorClass() {
      return this.disabled ? 'text-theme-black-450' : 'text-theme-black-850'
    },
    disabled() {
      if (this.item.showQuotaCount) {
        if (this.item.count === 0) return true
      }
      return this.item.disabled
    },
    isCheck() {
      return this.value.includes(this.item.id)
    },
    correct() {
      return this.correctAnswerList.find(i => i.id === this.item.id)
    },
    isCorrectAnswer() {
      return !!this.correctAnswerList.find(i => i.id === this.item.id)
    },
    itemText() {
      const content = this.item.content
      return content.richText || content.text
    }
  },
  methods: {
    onClick() {
      if (this.disabled) return
      this.$emit('click', this.item)
    },
    initAppendText() {
      const el = this.$refs.text
      if (!el) return
      if (this.item.showQuotaCount) {
        appendQuotaText(el, this.item.count, this.disabled)
      }
    }
  },
  mounted() {
    this.initAppendText()
  }
}
</script>
